import 'string.prototype.includes'
import { Provider } from 'react-redux'
import Pages from './pages'
import Store from './store'
import FormContext from './form'
import { hot } from 'react-hot-loader/root'
import { HashRouter } from 'react-router-dom'
import Analytics from './analytics'

import './font.css'

function App() {
  return (
    <Provider store={Store}>
      <Analytics>
        <HashRouter>
          <FormContext>
            <Pages />
          </FormContext>
        </HashRouter>
      </Analytics>
    </Provider>
  )
}

export default hot(App)
